<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <h3 class="page-header" style="margin-bottom: 0px;">
                    <i class="fa fa-building-o animated bounceInDown show-info"></i>
                    <span>Applied Job</span>
                </h3>
            </div>
            <div class="col-md-6 text-end">
                <button class="btn btn-primary mt-20" @click="refresh()">Refresh</button>
            </div>
        </div>
        <div class="col-md-12 table-responsive" style="padding:0px;">
            <div class="panel">
                <div class="panel-body table" style="overflow-x:auto;padding-left:0px">
                    <table class="table table-bordered table-font" style="margin-bottom:0;font-size:15px!important;">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Mobile No.</th>
                                <th>Email</th>
                                <th>Message</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(item, index) in appliedjobs" :key="item.id">
                                <td>{{ index + 1 }}</td>
                                <td>{{ item.name ? item.name : 'N/A' }}</td>
                                <td>{{ item.mobile ? item.mobile : 'N/A' }}</td>
                                <td>{{ item.email ? item.email : 'N/A' }}</td>
                                <td>{{ item.message ? item.message : 'N/A' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-md-12" style="margin-top: 20px">
            <nav aria-label="Page navigation example" style="text-align: right !important">
                <paginate style="margin: 0px !important; float: right" :page-count="noofpages"
                    :click-handler="clickCallback" :prev-text="'&laquo;'" :next-text="'&raquo;'"
                    :container-class="'pagination'">
                </paginate>
            </nav>
        </div>
    </div>
</template>
<script>
import Paginate from "vuejs-paginate";
import { mapGetters } from 'vuex'
import axios from 'axios'
import Constants from "../../components/utilities/Constants.vue";

export default {
    mixins: [Constants],
    components: { Paginate, },
    data() {
        return {
            currentpage: 1,
            noofrec: 10,
            count: 0,
            appliedjobs: [],

        }
    },
    computed: {
        ...mapGetters([

        ]),
        noofpages() {
            return Math.ceil(parseInt(this.count) / parseInt(this.noofrec))
        }

    },
    mounted() {
        this.refresh()
    },
    methods: {
        clickCallback(currentpage) {
            this.currentpage = currentpage
            this.refresh();
        },
        search() {
            this.currentpage = 1
            if (this.title != '' || this.city != '') {
                this.refresh()
            }
        },
        refresh() {
            let param = {
                noofrec: this.noofrec, currentpage: this.currentpage,
                title: this.title, city: this.city,
            }
            axios.post('api/jobs/appliedjob', param)
                .then(response => {
                    this.count = response.data.count
                    this.appliedjobs = response.data.data
                })
                .catch(error => {
                    console.log(error)
                })
        },
    },
}
</script>
